import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGutenbergComponent } from './simple-icons-gutenberg.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGutenbergComponent ],
    exports:      [ SimpleIconsGutenbergComponent ],
    bootstrap:    []
})
export class SimpleIconsGutenbergModule {}
